var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.gettingDeviceLocation
    ? 'cursor-not-allowed text-gray-500'
    : 'cursor-pointer text-darkgreen hover:text-darkgreen-600 duration-300'
  ],on:{"click":function($event){return _vm.click()}}},[(_vm.deviceLocationLabel)?_c('BaseIconText',{attrs:{"reversed":true,"icon-name":_vm.gettingDeviceLocation ? 'circle-notch' : 'location-dot',"rotate":_vm.gettingDeviceLocation,"label":_vm.deviceLocationLabel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }